import { createTheme } from "@mui/material";

import { createBreakpoints } from "@mui/system";
import { rootTheme } from "../utils/theme";
const breakpoints = createBreakpoints({});

export const styles = {
  logo: {
    width: "200px",
  },
  logo1: {
    width: "150px",
    marginRight: 10,
  },
  logoContainer: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  logoContainerHeader: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "center",
    alignItems: "center",
    flexGrow: 1,
  },
  selected: {
    backgroundColor: "rgba(6, 38, 85, 0.93)",
    border: '1px solid rgba(0, 136, 245, 0.7)',
    color: "#0088F5",
  }
};

export const buttontheme = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#fff",
          border: "1px solid rgba(0, 136, 245, 0.7);",
          width: "100%",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          marginTop: 10,
          background: "rgba(0, 136, 245, 0.15)",
          mixBlendMode: "screen",
          boxShadow: "0px 0px 8px rgba(87, 87, 245, 0.14)",
          borderRadius: "4px",
          display: "flex",
          fontSize: 16,
          height: "48px",
          textTransform: "capitalize",
          fontWeight: 700,
          "&.Mui-disabled": {
            opacity: 0.6,
            background: "rgba(0, 136, 245, 0.15)",
            mixBlendMode: "screen",
            boxShadow: "0px 0px 8px rgba(87, 87, 245, 0.14)",
            color: "#DDDDDD",
          },
          "&:hover": {
            background: "rgba(0, 136, 245, 0.15)",
          },
          "&:active": {
            background: "rgba(0, 136, 245, 0.15)",
          },
        },
      },
    },
  },
});

export const buttonTheme2 = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#F8F8F8",
          border: "1px solid rgba(0, 136, 245, 0.7);",
          width: "100%",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          marginTop: 10,
          color: "#F8F8F8",
          background: "#0088F5",
          mixBlendMode: "screen",
          boxShadow: "0px 0px 8px rgba(87, 87, 245, 0.14)",
          borderRadius: "4px",
          fontSize: 16,
          display: "flex",
          height: "48px",
          textTransform: "capitalize",
          fontWeight: 700,
          "&.Mui-disabled": {
            opacity: 0.6,
            background: "#0088F5",
            mixBlendMode: "screen",
            boxShadow: "0px 0px 8px rgba(87, 87, 245, 0.14)",
            color: "#DDDDDD",
          },
          "&:hover": {
            background: "#0088F5",
          },
          "&:active": {
            background: "#0088F5",
          },
        },
      },
    },
  },
});

export const buttonTheme3 = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#fff",
          border: "none",
          boxShadow: "none",
          width: "100%",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          marginTop: 10,
          color: "#0088F5",
          boxShadow: "none",
          background: "transparent;",
          mixBlendMode: "screen",
          borderRadius: "4px",
          display: "flex",
          fontSize: 16,
          height: "48px",
          textTransform: "capitalize",
          fontWeight: 700,
          "&.Mui-disabled": {
            opacity: 0.6,
            background: "rgba(0, 136, 245, 0.15)",
            mixBlendMode: "screen",
            boxShadow: "0px 0px 8px rgba(87, 87, 245, 0.14)",
            color: "#DDDDDD",
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
          "&:active": {
            backgroundColor: "transparent",
          },
        },
      },
    },
  },
});

export const buttonTheme4 = createTheme({
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#fff",
          border: "none",
          boxShadow: "none",
          width: "100%",
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          marginTop: 10,
          color: "#F8FAFF",
          boxShadow: "none",
          backgroundColor: "#56b306",
          mixBlendMode: "screen",
          borderRadius: "4px",
          display: "flex",
          fontSize: 16,
          height: "48px",
          textTransform: "capitalize",
          fontWeight: 700,
          "&.Mui-disabled": {
            opacity: 0.6,
            background: "#56b306",
            mixBlendMode: "screen",
            boxShadow: "0px 0px 8px #56b306",
            color: "#0088F5",
          },
          "&:hover": {
            backgroundColor: "transparent",
          },
          "&:active": {
            backgroundColor: "#56b306",
          },
        },
      },
    },
  },
});

export const buttonThemeOutlined = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          marginTop: 10,
          background: "transparent",
          mixBlendMode: "screen",
          boxShadow: "0px 0px 8px rgba(87, 87, 245, 0.14)",
          borderRadius: "4px",
          border: '2px solid #1976d2',
          display: "flex",
          fontSize: 16,
          height: "48px",
          textTransform: "capitalize",
          fontWeight: 700,
          "&.Mui-disabled": {
            opacity: 0.6,
            background: "rgba(0, 136, 245, 0.15)",
            mixBlendMode: "screen",
            boxShadow: "0px 0px 8px rgba(87, 87, 245, 0.14)",
            color: "#DDDDDD",
          },
          "&:hover": {
            background: "transparent",
          },
          "&:active": {
            background: "transparent",
          },
        },
      },
    },
  },
});

export const listTheme = createTheme({
  typography: {
    ...rootTheme.typography,
    allVariants: {
      color: "#F8FAFF",
      fontSize: 14,
      textTransform: "capitalize",
      [breakpoints.up("md")]: {
        fontSize: 18,
      },
    },
  },
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          cursor: "pointer",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          marginTop: 4,
          marginBottom: 4,
          backgroundColor: "rgba(0, 136, 245, 0.15)",
        },
      },
    },
  },
});

export const listThemeDate = createTheme({
  typography: {
    ...rootTheme.typography,
    allVariants: {
      color: "#F8FAFF",
      textTransform: "capitalize",
    },
  },
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          cursor: "pointer",
        },
      },
    },
  },
});

export const sidebar = createTheme({
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#0088F5",
            color: "#F8FAFF",
            "&:hover": {
              backgroundColor: "#0088F5",
            },
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 18,
          color: "#F8FAFF",
          fontFamily: `'Manrope', sans-serif`,
          textTransform: "capitalize",
          fontWeight: 700,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#003B6A",
          height: "100%",
        },
      },
    },
  },
});
